<div class="modal-wrapper" *ngIf="isOpen" (click)="clickedOutside($event)">
    <div class="modal-container">
      <div class="modal-content">
        <h1>{{ "login.caution" | translate }}</h1>
        <p>{{ "landing.app-body" | translate }}</p>
        <div class="buttons">
            <cowing-button
            (event)="redirectToStore()"
            [type]="EButtonType.Primary"
            [iconShow]="false"
            [label]="'landing.app-download' | translate"
            >
            </cowing-button>
            <cowing-button
            (event)="closeDialog()"
            [type]="EButtonType.Secondary"
            [iconShow]="false"
            [label]="'landing.app-close' | translate"
            >
            </cowing-button>
          </div>
        </div>
    </div>
  </div>